import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './useAuth';
import { pathWithEmpresa } from '../utils/companyUrl';

/** Ruta con ?empresa=ID según la empresa activa en la URL o en el contexto. */
export function useEmpresaPath(path) {
  const { empresaIdFromUrl, selectedCompany } = useAuth();
  const empresaId = empresaIdFromUrl || selectedCompany?.id;
  return pathWithEmpresa(path, empresaId);
}

/** Navegación que conserva ?empresa=ID en la ruta destino. */
export function useEmpresaNavigate() {
  const navigate = useNavigate();
  const { empresaIdFromUrl, selectedCompany } = useAuth();
  const empresaId = empresaIdFromUrl || selectedCompany?.id;

  return useCallback(
    (path, options) => navigate(pathWithEmpresa(path, empresaId), options),
    [navigate, empresaId]
  );
}
